import React, { useCallback, useEffect } from 'react'
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace'
import Divider from '@mui/material/Divider'
import {
    Grid,
    Tabs,
    Tab,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    Modal,
    Box,
    TextField,
    Button,
    Dialog,
} from '@material-ui/core'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import CheckboxOption from '../../../../ClinicalNotes/reusable/CheckboxOptions'
import './intakeModal.scss'
import { useNotification } from '../../../MaterialUi/Notification'
const truncateToPositiveInteger = (value) => {
    return Math.floor(Math.max(0, value))
}
const CustomTab = withStyles((theme) => ({
    root: {
        minWidth: 0,
        maxWidth: 'unset !important',
        [theme.breakpoints.up('sm')]: {
            minWidth: 0,
        },
        '& .MuiTab-root': {
            '& .MuiTab-wrapper': {
                background: 'transparent',
                // fontWeight: 500,
                fontFamily: 'Rubik',
                borderBottom: `4px solid #5571C6`,
                paddingBottom: '8px',
                paddingTop: '8px',
                color: '#242424 !important',
            },
        },
        '&.Mui-selected': {
            '& .MuiTab-wrapper': {
                background: 'transparent',
                fontWeight: 600,
                fontFamily: 'Rubik',
                borderBottom: `4px solid #5571C6`,
                paddingBottom: '8px',
                paddingTop: '8px',
                color: '#242424',
            },
        },
    },
    wrapper: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
}))((props) => <Tab {...props} />)
function TabPanel(props) {
    const { children, value, index, tabContentRef, setIsScroll, ...other } = props
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            className="modal-container"
            ref={tabContentRef}
            onScroll={() => setIsScroll(true)}
            {...other}>
            {value === index && (
                <Box sx={{ p: 3 }} className="modal-content">
                    {children}
                </Box>
            )}
        </div>
    )
}
const IntakeModalForm = ({
    open,
    toggleOpen,
    onModalClose,
    currentTab,
    setCurrentTab,
    tabContentRefs,
    isCheckboxEnabled,
    setIsCheckboxEnabled,
    setScrolledTabs,
    scrolledTabs,
    values,
    setValues,
    sign,
    setSign,
}) => {
    const [isScroll, setIsScroll] = React.useState(false)
    const notification = useNotification()
    React.useEffect(() => {
        const handleScroll = (index) => {
            if (!tabContentRefs.current[index]) {
                return
            }
            const contentHeight = tabContentRefs.current[index].clientHeight
            const scrollHeight = tabContentRefs.current[index].scrollHeight
            const scrollPosition = tabContentRefs.current[index].scrollTop
            const bottomPosition = scrollHeight - scrollPosition - contentHeight

            // Check if the user has scrolled to the bottom of the tab's content
            if (
                truncateToPositiveInteger(bottomPosition) >= 0 &&
                truncateToPositiveInteger(bottomPosition) <= 10 &&
                scrollPosition > 10
            ) {
                if (index !== 5) {
                    setCurrentTab(index + 1)
                    tabContentRefs.current[index + 1].scrollTop = 10
                }

                setScrolledTabs((prev) => {
                    // Store the index of the tab if it hasn't been stored already
                    if (!prev.includes(index)) {
                        return [...new Set([...prev, ...[index]])]
                    }
                    return prev
                })
            } else if (scrollPosition === 0 && index > 0 && bottomPosition !== 0) {
                setCurrentTab(index - 1)
            }
        }

        // Check if all tabs have been scrolled through
        setIsCheckboxEnabled(scrolledTabs?.length === 6)

        // Add scroll event listeners to each tab content

        tabContentRefs?.current?.forEach((_, index) => {
            tabContentRefs?.current[index]?.addEventListener('scroll', () => handleScroll(index))
        })

        // Remove event listeners when component unmounts
        return () => {
            tabContentRefs?.current?.forEach((_, index) => {
                tabContentRefs?.current[index]?.removeEventListener('scroll', () =>
                    handleScroll(index),
                )
            })
        }
    }, [scrolledTabs, currentTab, open, isScroll])

    React.useEffect(() => {
        if (tabContentRefs && tabContentRefs.current[currentTab]) {
            tabContentRefs.current[currentTab].scrollTop = 10
            if (
                tabContentRefs.current[currentTab].scrollHeight ===
                tabContentRefs.current[currentTab].clientHeight
            ) {
                setScrolledTabs((prev) => {
                    // Store the index of the tab if it hasn't been stored already
                    if (!prev.includes(currentTab)) {
                        return [...prev, currentTab]
                    }
                    return prev
                })
            }
            setIsCheckboxEnabled(scrolledTabs.length === 6)
        }
    }, [currentTab, tabContentRefs, scrolledTabs])

    const handleChange = (index) => {
        setCurrentTab(index)
    }
    const handleSaveSign = () => {
        if (sign) {
            setValues('termsSign', sign)
            setValues('releaseOfInfo', true)
            onModalClose()
        } else {
            notification('Please sign here', 'error')
        }
    }
    useEffect(()=>{
        if(values?.termsAgree == false || !sign ){
            setValues('releaseOfInfo', false)
        }
    },[values.termsAgree, sign])
    const goToPage = useCallback((url) => {
        window.open(url, '_blank');
    }, []);
    return (
        <Dialog  
            open={open}
            onClose={() => {
                toggleOpen(false)
            }}>
            <div className="terms-modal-new" style = {{ padding : "15px" }}>
                    <CheckboxOption
                        option={{
                            label: '',
                            value: true,
                        }}
                        // disabled={!isCheckboxEnabled}
                        customStyle={{
                            opacity: isCheckboxEnabled || values?.termsSign ? 1 : 0.5,
                            marginTop: 2,
                        }}
                        checked={values.termsAgree}
                        onChange={(event) => {
                            setValues('termsAgree', event.target.checked)
                            if(!event.target.checked){
                                setSign("")
                            }
                        }}
                    />
                    <div className="modal-footer-content">
                        <span
                            className="agreement"
                            style={{ opacity: isCheckboxEnabled || sign ? 1 : 0.5 }}>
                            I agree to the TeleMed2U{' '}
                            <span onClick={() => goToPage('https://www.telemed2u.com/terms-and-conditions-cdhp')}>Terms & Conditions</span>,{' '}
                            <span onClick={() => goToPage('https://www.telemed2u.com/informed-consent-for-medical-services')}>
                                Informed Consent for Medical Services
                            </span>
                            , <span onClick={() => goToPage('https://www.telemed2u.com/telehealth-consent-policy-cdhp')}>Telehealth Consent</span>,{' '}
                            <span onClick={() =>  goToPage('https://www.telemed2u.com/privacy-policy-cdhp')}>Privacy Policy</span> and{' '}
                            <span onClick={() => goToPage('https://www.telemed2u.com/notice-of-privacy-practices')}>
                                Notice of Privacy Practices
                            </span>
                            , and understand all of these can be accessed at any time on{' '}
                            <span onClick={() => goToPage('https://www.telemed2u.com')}>
                                telemed2u.com
                            </span>
                            . I have read and give my permission for the{' '}
                            <span onClick={() => setCurrentTab(5)}>Release of Information .</span>
                        </span>
                        <TextField
                            // onChange={handleChange}
                            style={{ opacity: isCheckboxEnabled || values?.termsSign ? 1 : 0.5 }}
                            disabled={!values.termsAgree}
                            required
                            name="sign"
                            value={sign}
                            // {...params}
                            placeholder="Sign name here"
                            variant="outlined"
                            onChange={(e) => setSign(e.target.value)}
                        />
                        {values.termsAgree ? (
                            <Button
                                style={{
                                    backgroundColor: !sign ? 'rgba(85, 113, 198, 0.75)' : '#5571c6',
                                    color: '#fff',
                                }}
                                onClick={handleSaveSign}
                                disabled={!sign && !values.termsAgree}>
                                Save
                            </Button>
                        ) : (
                            <Button style={{ backgroundColor: '#5571c6' }} onClick={onModalClose}>
                                Close
                            </Button>
                        )}
                    </div>
                </div>
        </Dialog>
    )
}

export default IntakeModalForm
